<template>
  <div class="dashboard">
    <component-navbar />
    <div class="jumbotron">
      <div class="container">
        <h1 class="display-4">
          {{ $t("secure.projects.headline") }} <b-badge>{{ this.$store.state.projects | count }}</b-badge>
        </h1>
        <p>AKTUELL: {{ this.$store.state.current_project_id }}</p>
        <ul class="list-group list-group-flush">
          <li v-for="(item,i) in this.$store.state.projects" :key="i" class="list-group-item">
            <a href="javascript:void(null);" class="btn btn-sm btn-info float-right p-0" @click="updateProject(item.id)">UPD</a>
            <a href="javascript:void(null);" class="btn btn-sm btn-info float-right p-0" @click="deleteProject(item.id)">DEL</a>
            <a v-if="item.id !== $store.state.current_project_id" href="javascript:void(null);" class="btn btn-sm btn-info float-right p-0" @click="setCurrentProject(item.id)">LIVE</a>
            <span v-if="item.id == $store.state.current_project_id"><b>LIVE</b></span>
            {{ item.name }} | <small>{{ item.created | moment("utc") | moment('timezone', 'Europe/Berlin', "L LTS") }} Uhr</small><br><small>{{ item.description }}</small>
          </li>
        </ul>
        <a href="javascript:void(null);" class="btn btn-info" @click="addProject()">Neues Projekt anlegen</a>
        <p class="lead">
          We hope you liked this tutorial and can now start building new astounding projects from this start point. If you're interested in what we're doing besides tech tutorials check out <a href="https://www.storyblok.com">@storyblok</a>.
        </p>
      </div>
    </div>
  </div>
</template>

<script>


import componentNavbar from '@/components/Navbar'

export default {
  components: {
    componentNavbar
  },
  data () {
    return {
      stories: []
    }
  },
  computed: {
    projectList () {
        return this.$store.state.projects
    }
  },
  mounted() {
  },
  methods: {
  }
}
</script>
